<aside [id]="information.panelId" class="information-panel" [hidden]="!information.expanded()"
  role="region" [attr.aria-labelledby]="information.panelId + '-title'" (keydown.escape)="escape($event)">
  <div class="d-flex align-items-start justify-content-between gap-3 p-3 border-bottom flex-shrink-0">
    <h2 #heading [id]="information.panelId + '-title'" class="h3 mb-0" tabindex="-1">
      {{ information.topic()?.title || 'Information' }}
    </h2>
    <button type="button" class="information-panel-action flex-shrink-0" aria-label="Close information panel"
      title="Close information panel" (click)="information.close()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon" aria-hidden="true" focusable="false">
        <path d="m18 6-12 12M6 6l12 12" />
      </svg>
    </button>
  </div>
  <div #body class="information-content p-3 overflow-auto flex-fill">
    <ng-container *ngIf="information.topic() as topic">
      <ng-container *ngTemplateOutlet="topic.content"></ng-container>
    </ng-container>
  </div>
</aside>
